// NetworkIndicators.js
//
// This file defines and exports two different components for displaying the state of the network:
// 1. NetworkErrorIndicator:
//      Displays a message to the user explaining that the connection to the
//      server has been lost, and that we will continue trying to reconnect
// 2. NetworkLoadingIndicator:
//      Displays a loading indicator when network requests are active.  Based on some CSS, fades in
//      the indicator slowly, so that we're not having it constantly flipping on and off

import { connect } from "react-redux";
import React from "react";
import { FormattedMessage } from "react-intl";
import { NETWORK_STATES } from "../util/networkManager";
import { map, mapObject, contains } from "underscore";
import { defaultUrls } from "../util/defaults";

import "./NetworkIndicators.css";

const urls = window.urls || defaultUrls;

// Given an object with {requestType: { ... transactionData ... }, returns a list of transaction
// states. E.g., ['PENDING', 'FETCHED', 'ERROR']
const getNetworkStates = networkTransactions => {
  return map(networkTransactions, function (transaction, name) {
    return transaction.state;
  });
};

export const NetworkErrorIndicatorComponent = props => {
  const transactionErrors = mapObject(
    props.networkTransactions,
    (transaction, name) => {
      return transaction.transactionError;
    }
  );
  if (contains(transactionErrors, true)) {
    return (
      <div className="error-box">
        <div>
          <img alt="Loading" src={urls["large-spinner"]} />
        </div>
        <div>
          <p>
            <FormattedMessage id="lost_connection" />
          </p>
        </div>
      </div>
    );
  }
  return null;
};

export const NetworkLoadingIndicatorComponent = props => {
  const transactionStates = getNetworkStates(props.networkTransactions);
  // By default, don't show the loading indicator
  let hidden = true;

  // If we're pending or fetching
  if (
    contains(transactionStates, NETWORK_STATES.PENDING) ||
    contains(transactionStates, NETWORK_STATES.FETCHING)
  ) {
    // Make it visible
    hidden = false;
  }
  // Always return an element, so we can use CSS transitions whenever we want to fade it in
  return (
    <img
      alt="Loading"
      src={urls["loading-bar"]}
      className={"loading-indicator" + (hidden ? " no-show" : "")}
    />
  );
};

const mapStateToProps = state => {
  return {
    networkTransactions: state.networkTransactions
  };
};

// We need to export the connected versions of the react components
export const NetworkErrorIndicator = connect(mapStateToProps)(
  NetworkErrorIndicatorComponent
);
export const NetworkLoadingIndicator = connect(mapStateToProps)(
  NetworkLoadingIndicatorComponent
);
